import { BaseButton } from "@app/components/common/BaseButton/BaseButton";
import { BaseImage } from "@app/components/common/BaseImage/BaseImage";
import styled, { css } from "styled-components";

export const ShortcutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const ShortcutTitle = styled.h1`
    color: #606060;
    font-family: 'Onest';
    font-weight: 700;
    font-size: 1.1rem;
    margin-top: 0.8rem;
    margin-left: 0.5rem;
    margin-bottom: 1rem;
`;

export const ShortcutTitleIcon = styled.img`
    width: 2.5rem;
    display: inline-block;
    margin-right: 0.5rem;
`;

export const ShortcutMenuWrapper = styled.div`

`;

export const ShortcutMenuItem = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const ShortcutMenuItemTitle = styled.div`
    color: #606060;
    font-size: 1rem;
    text-align: center;
    white-space: normal;
    margin-top: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 4.1em; /* Adjust based on line-height and desired number of lines */
    line-height: 1.3em; /* Adjust line-height as needed */
`;

export const ShortcutMenuButton = styled(BaseButton)`
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    display: block;
    border: 1px solid #bcbcbc;
    box-shadow: 2px 4px 8px #dcdcdc;
    height: auto;

    &:hover {
        background-color: #fff;
        border: 1px solid #939393;
    }
`;

export const ShortcutMenuImage = styled(BaseImage)`
    width: 75%;
    margin: 0 auto;
`;